<template>

  <app-layout title="Выкуп часов">

    <div
      class="buymodal">
      <h2
        v-if="model"
        class="buymodal-title">
        Заявка №{{ model.btag }}
      </h2>
      <div
        class="buymodal-block">

        <buymodal-header
          :headers="headers" />

        <transition
          name="slide-left"
          mode="out-in">

          <div
            class="buymodal-block__loader"
            v-if="loading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="grey"
              indeterminate
            ></v-progress-circular>
            <div><br></div>
            <div>Ожидайте, происходит определение устройства! Процесс может занять до 3х минут</div>
          </div>

          <screen-one
            v-if="!loading && headers[0].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />

          <screen-two
            v-if="!loading && headers[1].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />

          <screen-three
            v-if="!loading && headers[2].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />

        </transition>

      </div>
    </div>

    <refuse-modal
      @cancel="cancel" />
    <warning-modal />

  </app-layout>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import AppLayout from '../components/AppLayout.vue';
import BuymodalHeader from './components/AppleWatch/BuymodalHeader.vue';
import ScreenOne from './components/AppleWatch/Screens/ScreenOne.vue';
import ScreenTwo from './components/AppleWatch/Screens/ScreenTwo.vue';
import ScreenThree from './components/AppleWatch/Screens/ScreenThree.vue';
import RefuseModal from '@/components/Modals/RefuseModal.vue';
import WarningModal from '@/components/Modals/WarningModal.vue';

export default {
  name: 'apple-watch',
  components: {
    AppLayout,
    BuymodalHeader,
    ScreenOne,
    ScreenTwo,
    ScreenThree,
    RefuseModal,
    WarningModal,
  },
  data() {
    return {
      headers: [
        { name: 'Определение устройства', screenWin: true, active: true },
        { name: 'Расчет стоимости выкупа', screenWin: false, active: false },
        { name: 'Ввод данных клиента', screenWin: false, active: false },
        { name: 'Подтверждение выкупа', screenWin: false, active: false },
      ],
    };
  },
  created() {
    this.RESET_MODEL();
  },
  computed: {
    ...mapState('buymodels', ['model', 'loading']),
  },
  methods: {
    ...mapActions('buymodels', ['cancelModel']),
    ...mapMutations('buymodels', ['RESET_MODEL']),
    ...mapMutations('layout', ['SET_REFUSE_MODAL']),

    leave() {
      this.SET_REFUSE_MODAL({ bg: true, modal: true });
    },

    async cancel(data) {
      await this.cancelModel({
        btag: this.model.btag,
        refuseId: data.id,
      });

      this.RESET_MODEL();

      this.headers.map(item => ({
        ...item,
        screenWin: false,
        active: false,
      }));

      this.headers[0].screenWin = true;
      this.headers[0].active = true;
    },

    changeScreen(data) {
      const { type } = data;
      const { id } = data;
      let num = 0;

      if (type === 'next') {
        num = id + 1;
        this.headers[num].active = true;
      } else if (type === 'prev') {
        num = id - 1;
        this.headers[id].active = false;
      }

      this.headers[id].screenWin = false;
      this.headers[num].screenWin = true;
    },
  },
};
</script>

<style lang="sass">
  @import '@/styles/views/applewatch.sass'
</style>
